import lodash from 'lodash'
import Base, { criteriaIgnore } from "../base.store";

const baseUrl = '/api/v1/transaction/user-cas'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        meSave(context, { data, config }) {
            return base.request.put(`${baseUrl}/me`, data, { ...config });
        },
        meSaveAll(context, { data, config }) {
            return base.request.put(`${baseUrl}/me/_all`, data, { ...config });
        },
        meSearch(context, { criteria, config }) {
            criteria = lodash.cloneDeepWith(criteria, (value, key) => {
                if (criteriaIgnore.includes(key)) {
                    return null;
                }
            });
            return base.request.post(`${baseUrl}/me/_search`, criteria, { ...config });
        },
        meDelete(context, { id, config }) {
            return base.request.post(`${baseUrl}/me/_delete`, JSON.stringify(id), { ...config });
        },
        meDeleteAll(context, { ids, config }) {
            return base.request.post(`${baseUrl}/me/_delete_all`, ids, { ...config });
        },
        meActive(context, { id, config }) {
            return base.request.post(`${baseUrl}/me/_active`, JSON.stringify(id), { ...config });
        },
        meActiveAll(context, { ids, config }) {
            return base.request.post(`${baseUrl}/me/_active_all`, ids, { ...config });
        }
    },
    mutations: {
        ...base.mutations
    },
}
